// Editor för TextBlock — själva TinyMCE-instansen lever som persistent komponent
// i emailBuilderModal (för att undvika re-init-lagg). Denna editor visar bara
// en hjälptext eftersom TinyMCE visas där brödtexten faktiskt skrivs in.

import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const TextBlockEditor = () => {
  const { t } = useTranslation('groupMessage');
  return (
    <Stack spacing={1}>
      <Typography variant='body2' color='text.secondary'>
        {t('builder.editors.textBlockHint')}
      </Typography>
    </Stack>
  );
};

export default TextBlockEditor;
